import { Translation } from '@ps/web-shared-components';
import React from 'react';

import useWizardContext from '@swf/core/hooks/useWizardContext';

import type { CancelledCashoutStatus } from '../../../../types/status';
import Container from '../../../Container/Container';

import { TXTWCL_Request_successful } from './DepositPendingCashoutResult.messages.json';
import ResultButtons from './components/ResultButtons/ResultButtons';
import ResultContent from './components/ResultContent/ResultContent';

const DepositPendingCashoutResult: React.FC = () => {
  const {
    data: {
      cancelledWithdrawResult: { status },
      pendingCashouts
    }
  } = useWizardContext();

  return (
    <Container
      headerProps={{
        buttons: {},
        title: <Translation {...TXTWCL_Request_successful} />
      }}
      page={DepositPendingCashoutResult}
      helpSupportResolver
      showFooter
    >
      <ResultContent
        status={status as CancelledCashoutStatus}
        singleTransaction={pendingCashouts.length <= 1}
      />
      <ResultButtons />
    </Container>
  );
};

DepositPendingCashoutResult.displayName = 'DepositPendingCashoutResult';

export default DepositPendingCashoutResult;
